export default __webpack_public_path__ + "static/media/img3.469e9191.jpg";